import { axios } from '@/services/axios';

const acknowledgePlatformNumber = async (numberId, platformId, scope) => {
    const res = await axios.post(
        `/PlatformNumber/${numberId}/Platform/${platformId}/Acknowledged`,
        {
            headers: {
                'X-RequestScope': scope,
            },
        },
    );
    return res.data;
};
export default acknowledgePlatformNumber;
